import {Container} from "pixi.js";
import app from "@/app/index";

export default class AbstractView extends Container {

    /**
     *
     * @param name {String}
     */
    constructor({name = "Default"}) {
        super();
        this.name = name;
        this.build();
        this.initListeners();
    }

    build() {
        // Build your Container stuff
    }

    initListeners() {
        // Attach listeners like resize below
        app.resize.add(this.resized, this)
    };

    resized(size) {
    }

    show() {
        TweenMax.to(this, 0.8, {alpha: 1, ease: Expo.easeOut});
    }

    hide() {
        TweenMax.to(this, 0.8, {alpha: 0, ease: Expo.easeOut});
    }

    destroy() {
        super.destroy();
        app.resize.remove(this.resized, this);
    }
}



// WEBPACK FOOTER //
// ./src/app/pixi/views/AbstractView.js